import React from 'react';

import IconArrowDownSimple from 'components/icons/iconArrowDownSimple';

const MenuButtonLabel = ({ title }) => (
  <>
    <span>{title}</span>
    <span>
      <IconArrowDownSimple />
    </span>
  </>
);

export default MenuButtonLabel;
